import {FC} from 'react'

import {JurisdictionTooltip} from '@/components/trademark-renewal/form/jurisdictions/tooltip/JurisdictionTooltip'
import {TrademarkRenewalPrefillSource} from '@/components/trademark-renewal/form/types'
import {getPricingContent} from '@/content/pricing'
import {Jurisdiction} from '@/utils/countries/constants'
import {calculateTmRenewalJurisdictionPrice} from '@/utils/pricing/renewal/calculations'
import {routeTo} from '@/utils/router'
import {tmRenewalJurisdictions} from '@/utils/trademark-renewal/constants'

import {PricingCalculatorTable} from '../calculator/PricingCalculatorTable'
import {PricingTrademarkRenewalEstimationCard} from './PricingTrademarkRenewalEstimationCard'

const getLinkHref = (
  selectedJurisdictions: Jurisdiction[],
  classesByJurisdiction: Partial<Record<Jurisdiction, number>>,
  trademarksByJurisdiction: Partial<Record<Jurisdiction, number>>,
) =>
  routeTo.trademarkRenewal.form({
    jurisdictions:
      selectedJurisdictions.map((jurisdiction) => jurisdiction.toLowerCase()).join(',') ||
      undefined,
    classesCount:
      selectedJurisdictions
        .map((jurisdiction) => classesByJurisdiction[jurisdiction] ?? 1)
        .join(',') || undefined,
    trademarksCount:
      selectedJurisdictions
        .map((jurisdiction) => trademarksByJurisdiction[jurisdiction] ?? 1)
        .join(',') || undefined,
    prefillSource: TrademarkRenewalPrefillSource.Pricing,
  })

export const PricingTrademarkRenewalTable: FC = () => {
  const {subtitle, calculator} = getPricingContent().trademarkRenewal

  return (
    <PricingCalculatorTable
      subtitle={subtitle}
      startButtonText={calculator.startButtonText}
      continueButtonText={calculator.continueButtonText}
      getLinkHref={getLinkHref}
      trackedEventName="TrademarkRenewalButtonPricelist"
      EstimationCard={PricingTrademarkRenewalEstimationCard}
      allowedJurisdictions={tmRenewalJurisdictions}
      allowEuMemberSelection
      getJurisdictionPricing={(jurisdiction, currency) => ({
        price: calculateTmRenewalJurisdictionPrice(jurisdiction, currency).total.vatBase,
        renderTooltip: () => <JurisdictionTooltip jurisdiction={jurisdiction} hasPriceBreakdown />,
      })}
    />
  )
}
